/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  CreateViewMutationRequest,
  CreateViewMutationResponse,
} from "../types/CreateView.ts"

export const createViewMutationKey = () =>
  [{ url: "/v1/view/create-view" }] as const

export type CreateViewMutationKey = ReturnType<typeof createViewMutationKey>

/**
 * @summary Create a view
 * {@link /v1/view/create-view}
 */
export async function createView(
  data: CreateViewMutationRequest,
  config: Partial<RequestConfig<CreateViewMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateViewMutationResponse,
    ResponseErrorConfig<Error>,
    CreateViewMutationRequest
  >({
    method: "POST",
    url: `/v1/view/create-view`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createViewMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateViewMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createViewMutationKey()
  return mutationOptions<
    ResponseConfig<CreateViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateViewMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createView(data, config)
    },
  })
}

/**
 * @summary Create a view
 * {@link /v1/view/create-view}
 */
export function useCreateView<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateViewMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateViewMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateViewMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createViewMutationKey()

  const baseOptions = createViewMutationOptions(config) as UseMutationOptions<
    ResponseConfig<CreateViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateViewMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateViewMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateViewMutationRequest },
    TContext
  >
}
